import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import type {
  APITable,
  RelationColumnDataSourceConfig,
} from "../../../../../../../../api/infrastructure/table.formatter";
import { showToast } from "../../../../../../../shared/global-tools/toast-system";
import OurDropdown from "../../../../../../utils/OurDropdown/OurDropdown";
import "./index.scss";

interface RelationTableColumnFormProps {
  currentTable: APITable;
  tables: APITable[];
  relationConfig?: RelationColumnDataSourceConfig;
  close: () => void;
  onChange(config: RelationColumnDataSourceConfig): void;
  onCancel?(): void;
}

export default function RelationTableColumnForm({
  currentTable,
  tables,
  relationConfig,
  close,
  onChange,
  onCancel,
}: RelationTableColumnFormProps) {
  const [relationTable, setRelationTable] = useState("");
  const [relationTableColumn, setRelationTableColumn] = useState("");

  const handleSubmit = () => {
    if (!relationTable || !relationTableColumn) {
      showToast("Les champs de relation sont requis", {
        severity: "warn",
      });
      return;
    }
    onChange({
      relationTable,
      relationTableColumn,
    });
    close();
  };

  useEffect(() => {
    if (relationConfig) {
      setRelationTable(relationConfig.relationTable);
      setRelationTableColumn(relationConfig.relationTableColumn);
    }
  }, [relationConfig]);

  const otherTables = tables.filter((table) => table.id !== currentTable.id);
  const selectedRelationTable = otherTables.find((table) => table.name === relationTable);
  return (
    <div className="RelationTableColumnForm">
      <div className="RelationTableColumnForm-header">
        <h2 className="RelationTableColumnForm-headerTitle">Configuration relation</h2>
      </div>

      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}
      >
        <div className="RelationTableColumnForm-body">
          <label className="Field w-full">
            <span className="Field-label" style={{ fontWeight: 600, fontSize: "15px" }}>
              Table cible
            </span>
            <OurDropdown<string>
              initialOptions={otherTables.map((table) => ({
                value: table.name,
                label: table.label,
              }))}
              className="sm RelationTableColumnForm-dropdown"
              selectedOption={relationTable}
              onChange={setRelationTable}
              placeholder="Sélectionner"
            />
          </label>

          <label className="Field w-full">
            <span className="Field-label" style={{ fontWeight: 600, fontSize: "15px" }}>
              Champ cible
            </span>
            <OurDropdown<string>
              initialOptions={selectedRelationTable?.columns.map((column) => ({
                value: column.name,
                label: column.label,
              }))}
              className="sm RelationTableColumnForm-dropdown"
              selectedOption={relationTableColumn}
              onChange={setRelationTableColumn}
              placeholder="Sélectionner"
            />
          </label>
        </div>

        <div className="RelationTableColumnForm-footer">
          <Button
            type="button"
            label="Annuler"
            className="RelationTableColumnForm-btn Btn secondary outlined"
            onClick={() => {
              onCancel?.();
              close();
            }}
          />
          <Button
            type="submit"
            label="Enregistrer"
            className="RelationTableColumnForm-btn Btn primary"
            disabled={!relationTable || !relationTableColumn}
          />
        </div>
      </form>
    </div>
  );
}
